<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "VideoAi",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'videoAi:add',
        update: 'videoAi:update',
        delete: 'videoAi:delete',
        deleteBatch: 'videoAi:deleteBatch'
      },
      url: {
        get: '/videoAi/listByCondition',
        add: '/videoAi/add',
        update: '/videoAi/update',
        delete: '/videoAi/delete/',
        delete_batch: '/videoAi/deleteBatch',
        status: '/videoAi/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      },{
        field: 'phone',
        label: '用户',
        show: true,
        width: '',
      },{
        field: 'presenterId',
        label: '数字人Id',
        show: true,
        width: '',
      }, {
        field: 'videoUrl',
        label: '视频URL',
        show: true,
        width: '',
      },{
        field: 'text',
        label: '文本内容',
        show: true,
        width: '',
      },{
        field: 'coverUrl',
        label: '封面',
        show: true,
        width: '',
      },{
        field: 'status',
        label: '活动状态',
        show: {
          type: 'tag',
          tags: [{
            key: 0,
            value: '生成中',
            type: 'warning',
          }, {
            key: 1,
            value: '成功',
            type: 'primary'
          }, {
            key: 2,
            value: '失败',
            type: 'danger'
          }]
        },
      },{
        field: 'videoId',
        label: '视频ID',
        show: true,
        width: '',
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }],
      operate: [],
      formFields: {
        addTitle: '视频Ai',
        updateTitle: '视频Ai',
        model: [{
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        },{
          field: 'userName',
          label: '用户名',
          type: 'input',
          placeholder: '用户名',
          rules: [{message: '请输入用户名', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }, {
          field: 'presenterId',
          label: '数字人ID',
          type: 'input',
          placeholder: '数字人ID',
          rules: [{message: '请输入数字人ID', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'videoUrl',
          label: '视频URL',
          type: 'input',
          placeholder: '视频URL',
          rules: [{message: '请输入视频URL', trigger: 'blur', required: true}],
          add: true,
          update: true,
        },  {
          field: 'text',
          label: '文本内容',
          type: 'editor',
          placeholder: '文本内容',
          rules: [{message: '请输入文本内容', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }, {
          field: 'coverUrl',
          label: '封面URL',
          type: 'input',
          placeholder: '封面URL',
          rules: [{message: '请输入封面URL', trigger: 'blur', required: true}],
          add: true,
          update: true,
        },{
          field: 'status',
          label: '状态',
          type: 'input',
          placeholder: '状态',
          rules: [{message: '请输入状态', trigger: 'blur', required: true}],
          add: true,
          update: true,
        },{
          field: '视频ID',
          label: '视频ID',
          type: 'input',
          placeholder: '视频ID',
          rules: [{message: '请输入视频ID', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }],
      }
    }
  }
}
</script>

<style scoped>

</style>
